// @need-translate
import {requestContext} from '../../../common/requestContext';
import {twMerge} from '../../../common/twMerge';
import {theme} from '../../../theme';
import {Divider} from '../../atoms/Divider/Divider';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';

export function Right() {
  const {isMobile, isWebView} = requestContext.requestInfo.display;

  const handleDownloadClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isWebView) {
      e.preventDefault();
      const url = e.currentTarget.getAttribute('href');
      if (url) {
        window.open(url, '_blank');
      }
    }
  };

  return (
    <>
      <header>카카오페이지 권리침해신고센터</header>
      <main>
        <p>
          권리침해신고센터는 저작권자의 저작권 침해에 대한 예방과 중지, 이용자의
          명예훼손 또는 개인정보 침해 발생시 게시물의 차단, 자기게시물 접근 배제
          등을 요청할 수 있는 창구입니다.
        </p>
        <section>
          <h2>권리침해 신고 처리 절차</h2>
          <div
            className={twMerge('flex', isMobile && 'max-w-[440px] flex-col')}
          >
            <StaticImage imageType={StaticImageType.PolicyRight01} />
            <Divider
              className={twMerge(
                isMobile && 'my-24pxr!',
                !isMobile && 'mx-auto mt-0!'
              )}
              color={theme.colors['theme-transparent-10']}
              direction={isMobile ? 'horizontal' : 'vertical'}
            />
            <StaticImage imageType={StaticImageType.PolicyRight02} />
          </div>
        </section>
        <section>
          <h2>명예훼손/개인정보침해 등 신고 안내</h2>
          <p>
            카카오페이지 서비스내 게시물, 댓글 등을 통해 명예훼손, 개인정보
            도용, 개인정보 침해, 초상권 침해 등이 발생하여 자신의 권리가 침해된
            권리자 또는 피해자는 해당 게시문의 차단을 신청할 수 있습니다.
          </p>
          <table cellSpacing="0" cellPadding="0">
            <colgroup>
              <col width="100%" />
            </colgroup>
            <tbody>
              <tr>
                <th className="text-center!">명예훼손 및 개인정보 침해 신고</th>
              </tr>
              <tr>
                <td>
                  <h4>개인의 사생활 침해 허위사실 유언비어 유포 행위등</h4>
                  <p>
                    <strong>증빙서류</strong>
                  </p>
                  <ul>
                    <li>
                      게시물 차단 신청서{' '}
                      <a
                        href={'/public/download/1.게시물_차단_신청서.doc'.normalize()}
                        onClick={handleDownloadClick}
                      >
                        [다운로드]
                      </a>
                    </li>
                    <li>권리침해 사실을 소명할 수 있는 자료</li>
                  </ul>
                  <p>
                    <strong>본인 확인 서류 1부</strong>
                  </p>
                  <ul>
                    <li>
                      개인 : 신분증 사본(대리인 신고 시{' '}
                      <a
                        href={'/public/download/위임장_법정대리인.zip'.normalize()}
                        onClick={handleDownloadClick}
                      >
                        위임장
                      </a>
                      , 주민등록번호 뒷 7자리 마스킹(가림처리))
                    </li>
                    <li>
                      단체 : 사업자등록증 사본 및{' '}
                      <a
                        href={'/public/download/위임장_법정대리인.zip'.normalize()}
                        onClick={handleDownloadClick}
                      >
                        위임장
                      </a>
                      , 대리인 신분증 사본(주민등록번호 뒷 7자리 등
                      마스킹(가림처리))
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <em>
          ※ 2014년 8월 7일 개인정보보호법 시행에 따라 주민등록번호 수집·이용이
          금지되었습니다. 주민등록번호 뒷자리 7자리를 마스킹하여 보내주시지 않는
          신분증의 경우 즉시 파기하여 접근배제요청이 거부됩니다.
        </em>
        <section>
          <h2>저작권 침해신고 안내</h2>
          <ol>
            <li>
              <span>1.</span>
              카카오페이지 서비스내 저작물 등의 복제·전송으로 인해 자신의
              저작권법상의 권리가 침해되었다고 주장하는 권리자는 하단의
              증빙서류를 갖추어 회사에 저작물등에 대한 복제·전송의 중단을
              요청하실 수 있습니다.
              <br />
              *저작권법상의 권리에 대한 몇백한 침해가 확인될 경우 즉시 삭제
              처리될 수 있습니다
            </li>
            <li>
              <span>2.</span>
              저작물등의 복제·전송의 재개 요청은 중단을 통보받은 날로부터 30일
              이내에 재개요청서
              <a
                href={'/public/download/3.게시물_재개_요청서.doc'.normalize()}
                onClick={handleDownloadClick}
              >
                [다운로드]
              </a>
              와 소명자료를 제출함으로써 가능하며, 재개요청자가 저작권자이거나,
              정당한 권리자임을 증빙할 수 있는 경우에만 요청이 가능합니다.
            </li>
            <li>
              <span>3.</span>
              회사는 재개요청에 대하여 저작권법상 절차에 따라 저작물등의 영구
              게재 중단 결정 또는 재개 예정일의 통보를 하게 됩니다.
            </li>
            <li>
              <span>4.</span>
              복제·전송이 재개된 게시물에 대해서는 다시 권리침해신고 절차를
              통하여 중단을 요청할 수 없습니다. 이후에는 당사자간의 협의 또는
              법원의 판결을 통해 중단이 가능합니다.
            </li>
          </ol>
          <table cellSpacing="0" cellPadding="0">
            <colgroup>
              <col width="100%" />
            </colgroup>
            <tbody>
              <tr>
                <th className="text-center!">저작권 침해 신고시 증빙서류</th>
              </tr>
              <tr>
                <td>
                  <p>타인의 저작권을 무단 사용하여 게재하는 행위 등</p>
                  <p>
                    <strong>증빙서류</strong>
                  </p>
                  <ul>
                    <li>
                      복제·전송 중단 요청서{' '}
                      <a
                        href={'/public/download/4.복제_전송_중단_요청서.docx'.normalize()}
                        onClick={handleDownloadClick}
                      >
                        [다운로드]
                      </a>
                    </li>
                    <li>
                      신고자가 해당 저작물의 권리자로 표시된 자료 사본 (또는
                      그에 해당하는 자료)
                    </li>
                    <li>
                      자신의 서명 등 또는 이명 등으로서 널리 알려진 것이
                      표시되어 있는 저작물의 사본 (또는 그에 상당하는 자료)
                    </li>
                  </ul>
                  <p>
                    <strong>본인 확인 서류 1부</strong>
                  </p>
                  <ul>
                    <li>
                      개인 : 신분증 사본(대리인 신고 시{' '}
                      <a
                        href={'/public/download/위임장_법정대리인.zip'.normalize()}
                        onClick={handleDownloadClick}
                      >
                        위임장
                      </a>
                      , 주민등록번호 뒷 7자리 마스킹(가림처리))
                    </li>
                    <li>
                      단체 : 사업자등록증 사본 및{' '}
                      <a
                        href={'/public/download/위임장_법정대리인.zip'.normalize()}
                        onClick={handleDownloadClick}
                      >
                        위임장
                      </a>
                      , 대리인 신분증 사본(주민등록번호 뒷 7자리 등
                      마스킹(가림처리))
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section>
          <h2>자기게시물 접근배제 요청 안내</h2>
          <p>
            인터넷 자기게시물 접근 배제 요청권은 헌법상의 개인정보 자기결정권,
            행복추구권 및 사생활의 비밀과 자유, 그리고 정보통신망법상의
            정보통신서비스제공자의 책무 등에 근거하여 이용자 본인이 인터넷상
            게시한 게시물에 대하여 타인의 접근 배제를 요청할 수 있는 권리를
            말합니다.
          </p>
          <section>
            <h3>자기게시물 접근 배제 요청 대상</h3>
            <ol>
              <li>
                <span>1.</span>
                카카오페이지 회원 탈퇴로 회원정보가 파기됨에 따라 이용자 본인이
                직접 삭제할 수 없는 게시물인 경우
              </li>
              <li>
                <span>2.</span>
                사자(死者)가 생전에 접근 배제 요청권의 행사를 위임한 지정인 또는
                유족이 사자(死者)의 인터넷 게시물에 대한 접근 배제를 요청하는
                경우
              </li>
              <li>
                <span>3.</span>
                이메일 또는 휴대폰번호 가입 회원중 가입하였던 이메일 또는
                휴대전화번호가 삭제되어 본인확인이 불가능할 경우
              </li>
              <li>
                <span>4.</span>
                관리자가 사업의 폐지 등으로 사이트 관리를 중단한 경우
              </li>
            </ol>
            <table cellSpacing="0" cellPadding="0">
              <colgroup>
                <col width="50%" />
                <col width="50%" />
              </colgroup>
              <tbody>
                <tr>
                  <th
                    colSpan={2}
                    className="border-b-1 border-solid border-theme-solid-20"
                  >
                    자기게시물 접근배제 관련 증빙서류
                  </th>
                </tr>
                <tr>
                  <th className="border-r-1 border-solid border-theme-solid-20">
                    본인이 직접 신청할 경우
                  </th>
                  <th>위임인을 지정하여 위임인이 신청할 경우</th>
                </tr>
                <tr>
                  <td className="border-r-1 border-solid border-theme-solid-20 align-top!">
                    <ul className="[&>*:not(:last-child)]:mb-45pxr">
                      <li>
                        자기게시물 접근배제 요청서{' '}
                        <a
                          href={'/public/download/5.자기게시물_접근배제_요청서.doc'.normalize()}
                          onClick={handleDownloadClick}
                        >
                          [다운로드]
                        </a>
                      </li>
                      <li>
                        신분증 사본 : 성명, 생년월일 외에 주민등록번호 뒷
                        7자리는 마스킹하여 첨부
                      </li>
                      <li>자기게시물임을 증빙할 수 있는 기타 증빙서류</li>
                    </ul>
                  </td>
                  <td className="align-top!">
                    <ul className="[&>*:not(:last-child)]:mb-20pxr">
                      <li>
                        자기게시물 접근배제 요청서{' '}
                        <a
                          href={'/public/download/5.자기게시물_접근배제_요청서.doc'.normalize()}
                          onClick={handleDownloadClick}
                        >
                          [다운로드]
                        </a>
                      </li>
                      <li>
                        접근배제 요청인 지정서{' '}
                        <a
                          href={'/public/download/6.접근배제요청인_지정서.doc'.normalize()}
                          onClick={handleDownloadClick}
                        >
                          [다운로드]
                        </a>
                      </li>
                      <li>
                        신분증 사본 : 성명, 생년월일 외에 주민등록번호 뒷
                        7자리는 마스킹하여 첨부
                      </li>
                      <li>자기게시물임을 증빙할 수 있는 기타 증빙서류</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </section>
        <section>
          <h2>자기게시물 접근 배제 요청시 유의사항</h2>
          <section>
            <p>자기게시물 접근 배제 요청 대상</p>
            <ol>
              <li>
                <span>1.</span>
                타인의 게시물에 대하여 부당한 방법을 사용하여 접근 배제를
                요청하는 경우, 관련 법률에 따라 민형사상의 책임을 부담할 수
                있습니다.
              </li>
              <li>
                <span>2.</span>
                계정 정보를 분실하여 본인이 삭제하기 어려운 경우 계정찾기 및
                비밀번호 찾기등을 이용 부탁드립니다.
              </li>
              <li>
                <span>3.</span>
                이용자 본인의 접근 배제요청 대상은 정보통신망을 통하여 이용자
                본인이 게시한 글에 준하는 기타 게시물을 말합니다. (본인만 열람이
                가능한 비공개 게시글은 접근배제 요청대사에 포함되지 않습니다. )
              </li>
              <li>
                <span>4.</span>
                방송통신위원회에서 발표한 가이드라인에 따르면 게시물 작성자가
                본인임을 입증할 수 없다면 접근배제 요청이 불가능합니다.
              </li>
            </ol>
          </section>
        </section>
      </main>
      <footer>
        <p>이 약관은 2018년 9월 1일부터 적용됩니다.</p>
      </footer>
    </>
  );
}
